<video id='m3u8video' *ngIf="!router.url.includes('stream')" width="100%" autoplay height='100%' class="video-js vjs-default-skin" on-ended="videoEnded()"
controls controlsList="nodownload" [ngClass]="{'video-album': openFrom == 'VideoAlbum'}">
    <!-- <source [src]="videoUrl" type="application/x-mpegURL"> -->
</video>
<video id='m3u8video' *ngIf="router.url.includes('stream')" controls controlsList="nodownload" width="100%" autoplay height='100%' class="video-js vjs-default-skin h-100" >
    <!-- <source [src]="videoUrl" type="application/x-mpegURL"> -->
</video>